
import { Checkbox, Toggle } from '05-ui-kit';
import isTouchDevice from 'is-touch-device';
import { computed, onMounted, onUnmounted, ref, shallowRef, watch } from '@nuxtjs/composition-api';
import TSProductCard from '../ts-components/TSProductCard/TSProductCard.vue';
import CompareProductCard from '../CompareProductCard/CompareProductCard.vue';
import TSBonusCount from '../ts-components/TSBonusCount/TSBonusCount.vue';
import isInsideViewport from '~/helper/isInsideViewport';
import type { Product } from '~/type/product/Product';
import type { CompareCharacteristic, CompareProperty } from '~/type/Compare';
import ActionFavorite from '~/action/ActionFavorite.vue';
import ActionCompare from '~/action/ActionCompare.vue';
import { useUserListStore } from '~/store/userLists';
import { useResizeStore } from '~/store/resize';
const __sfc_main = {};
__sfc_main.props = {
  products: {
    key: "products",
    required: true,
    type: Array
  },
  properties: {
    key: "properties",
    required: true,
    type: Array
  },
  categoryIndex: {
    key: "categoryIndex",
    required: true,
    type: Number
  },
  path: {
    key: "path",
    required: false,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const row = shallowRef<HTMLDivElement>();
  const isSticky = ref(false);
  const compareColWidth = ref(303);
  const needSlidePx = ref(0);
  const showOnlyDifferent = ref(false);
  const showSliderButtons = ref(false);
  const isOverlayProductSlider = ref(true);
  const startX = ref(0);
  const cardRef = ref<Element[]>([]);
  const userListStore = useUserListStore();
  const resizeStore = useResizeStore();
  const listOrder = ref<number[]>();
  const selectedDragIndex = ref<number>();
  const _mouseMove = ref();
  const _mouseUp = ref();
  let unsubscribeIsMobile: () => void;
  let unsubscribeCompareUserList: () => void;
  const sliderWidth = computed(() => listOrder.value ? listOrder.value?.length * compareColWidth.value : 0);
  const disableLeft = ref<boolean>();
  const disableRight = ref<boolean>();
  watch(() => needSlidePx.value, val => {
    disableLeft.value = val === 0;
    if (rowWidth()) disableRight.value = val === rowWidth() - sliderWidth.value;
    if (disableRight.value) isOverlayProductSlider.value = false;else isOverlayProductSlider.value = true;
  }, {
    immediate: true
  });
  watch(() => props.products, () => {
    listOrder.value = props.products.map((_, index) => index);
  });
  watch(() => listOrder.value, val => {
    if (update) update();
    if (val && val.length < 2) showOnlyDifferent.value = false;
    emit('compare-change-tab', {
      isSliderShowButtons: showSliderButtons.value
    });
    if (val && val.length <= 0) emit('compare-change-tab', {
      categoryIndex: props.categoryIndex
    });
  });
  const favoriteIds = computed(() => userListStore.compare);
  listOrder.value = props.products.map((_, index) => index);
  props.products.forEach((el, index) => {
    if (!favoriteIds.value[el.id]) handleDeleteProduct({
      index
    });
  });
  onMounted(() => {
    update();
    unsubscribeIsMobile = resizeStore.$onAction(mutation => {
      if (mutation.name === 'setIsMobile') update();
    });
    if (rowWidth() === sliderWidth.value) isOverlayProductSlider.value = false;
    handleScroll();
    document.addEventListener('scroll', handleScroll, {
      passive: true
    });
  });
  onUnmounted(() => {
    if (unsubscribeIsMobile) unsubscribeIsMobile();
    if (unsubscribeCompareUserList) unsubscribeCompareUserList();
    window.removeEventListener('mousemove', _mouseMove.value);
    window.removeEventListener('mouseup', _mouseUp.value);
  });
  const compareProductSlider = shallowRef<HTMLDivElement>();
  function handleScroll() {
    if (compareProductSlider.value) isSticky.value = isInsideViewport(compareProductSlider.value);
  }
  function handleDragOver({
    index
  }: {
    index: number;
  }) {
    if (selectedDragIndex.value === undefined || selectedDragIndex.value === index) return;
    if (selectedDragIndex.value !== undefined && listOrder.value?.length) {
      const dragIndex = listOrder.value.indexOf(selectedDragIndex.value);
      const dragOverIndex = listOrder.value.indexOf(index);
      listOrder.value.splice(dragIndex, 1);
      listOrder.value.splice(dragOverIndex, 0, selectedDragIndex.value);
    }
  }
  function handleDragStart({
    index,
    event
  }: {
    index: number;
    event: MouseEvent;
  }) {
    event.preventDefault();
    selectedDragIndex.value = index;
    const card = cardRef.value[index];
    const ghost = (card.cloneNode(true) as HTMLElement);
    const clientRect = card.getBoundingClientRect();
    ghost.style.position = 'absolute';
    ghost.style.width = `${compareColWidth.value}px`;
    ghost.style.top = `${clientRect.top}px`;
    ghost.style.left = `${clientRect.left}px`;
    ghost.style.zIndex = '1';
    ghost.style.opacity = '0.6';
    ghost.style.pointerEvents = 'none';
    const mousePressX = event.clientX;
    const initX = clientRect.left;
    _mouseMove.value = (e: MouseEvent) => {
      e.preventDefault();
      ghost.style.left = `${initX + e.clientX - mousePressX}px`;
    };
    _mouseUp.value = () => {
      window.removeEventListener('mousemove', _mouseMove.value);
      window.removeEventListener('mouseup', _mouseUp.value);
      ghost.remove();
      selectedDragIndex.value = undefined;
    };
    document.body.appendChild(ghost);
    window.addEventListener('mousemove', _mouseMove.value);
    window.addEventListener('mouseup', _mouseUp.value);
  }
  function handleTouchStart(e: TouchEvent) {
    startX.value = e.changedTouches[0].screenX;
  }
  function handleTouchEnd(e: TouchEvent) {
    const diffX = e.changedTouches[0].screenX - startX.value;

    // Ignore small movements.

    if (Math.abs(diffX) >= 40) {
      if (diffX >= 0) {
        e.preventDefault();
        prev();
      } else {
        e.preventDefault();
        next();
      }
    }
  }
  function handleDeleteProduct({
    index
  }: {
    index: number;
  }) {
    if (listOrder.value && listOrder.value?.length > 0) {
      listOrder.value.splice(index, 1);
      if (listOrder.value.length > 0) emit('compare-change-tab-count', {
        categoryIndex: props.categoryIndex,
        count: listOrder.value.length
      });
    }
    update();
  }
  function isDifferentProperties(properties: CompareCharacteristic) {
    const isDiff = [...new Set(properties.specification?.map(spec => spec.value))].length;
    return isDiff !== 1;
  }
  function update() {
    // Если экран меньше 800 делаем колонки узкими
    compareColWidth.value = resizeStore.isMobile ? 165 : 303;

    // Проверяем есть ли поддержка тач
    if (isTouchDevice()) {
      showSliderButtons.value = false;
    } else if (rowWidth() < sliderWidth.value) {
      showSliderButtons.value = true;
    } else {
      showSliderButtons.value = false;
      needSlidePx.value = 0;
    }
  }
  function alignSliderRight() {
    needSlidePx.value = rowWidth() - sliderWidth.value;
  }
  function alignSliderLeft() {
    needSlidePx.value += Math.abs(needSlidePx.value % compareColWidth.value);
  }
  function next() {
    const hasFreeSpace = rowWidth() > sliderWidth.value;
    if (hasFreeSpace) return;
    if (!disableRight.value) {
      const freeSpaceForSlider = sliderWidth.value - Math.abs(needSlidePx.value) - compareColWidth.value;
      if (freeSpaceForSlider < rowWidth()) return alignSliderRight();
      needSlidePx.value -= compareColWidth.value;
    }
  }
  function prev() {
    const hasFreeSpace = rowWidth() > sliderWidth.value;
    if (hasFreeSpace) return;
    if (!disableLeft.value) {
      if (Math.abs(needSlidePx.value) % compareColWidth.value !== 0) return alignSliderLeft();
      needSlidePx.value += compareColWidth.value;
    }
  }
  function rowWidth() {
    return row.value?.offsetWidth || 0;
  }
  return {
    isTouchDevice,
    emit,
    row,
    isSticky,
    needSlidePx,
    showOnlyDifferent,
    showSliderButtons,
    isOverlayProductSlider,
    cardRef,
    listOrder,
    disableLeft,
    disableRight,
    compareProductSlider,
    handleDragOver,
    handleDragStart,
    handleTouchStart,
    handleTouchEnd,
    handleDeleteProduct,
    isDifferentProperties,
    next,
    prev
  };
};
__sfc_main.components = Object.assign({
  Checkbox,
  TSProductCard,
  ActionFavorite,
  ActionCompare,
  TSBonusCount,
  Toggle,
  CompareProductCard
}, __sfc_main.components);
export default __sfc_main;
